module.exports = __webpack_public_path__ + "img/用户管理.18248d22.png";